<template>
    <div>
        <v-navigation-drawer 
        v-model="drawer"
        app
        clipped
        expand-on-hover
        >
        <v-list
            dense
            nav
        >
            <router-link 
                v-for="item in items"
                :key="item.title"
                link
                :to="item.goTo"
            >
                <v-list-item :class="[(currentPage === item.name) ? activeClass : '']"> 
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                
            </router-link> 

        </v-list>
        </v-navigation-drawer>

        <v-app-bar
        app
        clipped-left
        >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title @click="goHome()" class="home-btn">{{ title }}</v-toolbar-title>
        
        <!-- place holder -->
        <div class="flex-grow-1"></div>
        
        <!-- Avatar -->
        <v-chip pill>
            <v-avatar
                left
                color="#ff4081"
            >
                {{ userFirstChar }}
            </v-avatar>
            {{ userName }}
        </v-chip>
        <!-- Logout -->
        <v-btn @click="doLogout()" rounded icon class="logout-btn">
            <v-icon>mdi-logout</v-icon>
        </v-btn>
        </v-app-bar>
        <!-- <v-breadcrumbs :items="currentpage" divider="-"></v-breadcrumbs> -->
        
    </div>
</template>

<script>

import { UserService } from '../services/userLogin.service'
import Vue from 'vue'

export default {
    name: 'Navbar',
    data: () => ({
        title: 'Sales Dash 3',
        activeClass: 'active',
        drawer: true,
        currentpage: [
            { text: 'Dashboard', disabled: false },
            { text: 'Products Management' }
        ],
        items: [
            { name: 'Dashboard', disabled: true, icon: 'mdi-view-dashboard', goTo:'/Dash' },
            { name: 'Products Management', disabled: false, icon: 'mdi-playlist-edit', goTo:'/Products' }
        ],
        right: true
    }),
    methods:{
        doLogout() {
            UserService.logout();
            this.$router.replace("/Login");
        },
        goHome() {
            this.$router.replace("/");
        }
    },
    computed: {
        currentPage() {
            let path = this.$router.currentRoute.name;
            return path;
        },
        userName(){
            let userName = localStorage.getItem("email");
            return userName?userName:"";
        },
        userFirstChar(){
            return this.userName.substring(0,1).toUpperCase();
        }
    }
}
</script>

<style scoped>
    a {  text-decoration: none;}
    .active div i{
        color: #ff4081 !important;
        caret-color: #ff4081 !important;
    }
    .logout-btn{
        margin-left: 5px;
    }
    .home-btn{
        cursor: pointer;
    }
</style>